
import { Vue, Component, Prop } from 'vue-property-decorator';
import ShowEventBase from '@/ui/components/devices/devices/base/ShowEventBase.vue';
import SwitchBase from '@/ui/components/devices/devices/base/SwitchBase.vue';
import PushButtonBase from '@/ui/components/devices/devices/base/PushButtonBase/index.vue';
import OutputFieldBase from '@/ui/components/devices/devices/base/OutputFieldBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import LabelUnitWrapper from '@/ui/components/devices/components/LabelUnitWrapper.vue';
import { IDevice } from '@/types/devices.types';

/**
 * Component that represent Generator device
 */
@Component({
  components: {
    ShowEventBase,
    SwitchBase,
    PushButtonBase,
    OutputFieldBase,
    DeviceLayout,
    LabelUnitWrapper,
  },
})
export default class Generator extends Vue {
  @Prop() deviceData!: IDevice;

  get langPath() {
    return `devices.${this.deviceData.data.type}`;
  }

  get isActualValueVariableFilled() {
    return !!this.deviceData.data.mappings.OutputField_actualValue.length;
  }
}
